import { Divider, Tooltip } from "@mui/material";
import React from "react";

// Callers pass a strong red or blue; the label gets a soft tint and a calmer text tone.
const TONES = {
  "#ff0822": { bg: "#FDECEC", fg: "#C42B1C", border: "#F7C9C4" },
  "#0093ff": { bg: "#E8F3FF", fg: "#0B63B6", border: "#C4DFFB" },
};

const tooltipSx = {
  tooltip: {
    sx: {
      backgroundColor: "#ffffff",
      boxShadow: "rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.35) 0px 12px 24px -4px",
      color: "black",
      fontSize: "13px",
      fontWeight: 500,
      padding: "15px",
      textAlign: "left",
      maxWidth: "450px",
    },
  },
  arrow: { sx: { fontSize: 16, color: "#ffffff" } },
};

// Status label next to an order number, e.g. "Missing Quotation" or "Supplier note".
const ColoredSVG = ({ backgroundColor, file: Icon, color, text, productsWithNotes }) => {
  const tone = TONES[color?.toLowerCase()] || { bg: backgroundColor, fg: color, border: "transparent" };

  const label = (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        flexShrink: 0,
        whiteSpace: "nowrap",
        background: tone.bg,
        color: tone.fg,
        border: `1px solid ${tone.border}`,
        borderRadius: "999px",
        padding: "3px 9px 3px 7px",
        fontSize: "11px",
        fontWeight: 600,
        lineHeight: 1.2,
      }}
    >
      {Icon && <Icon width="11" height="11" fill={tone.fg} style={{ flexShrink: 0 }} />}
      {text}
    </span>
  );

  if (!(productsWithNotes?.length > 0)) return label;

  return (
    <Tooltip
      componentsProps={tooltipSx}
      title={
        <div>
          <h4 style={{ textAlign: "center", fontWeight: 600, fontSize: "16px" }}>Supplier notes</h4>
          <Divider sx={{ marginBottom: "20px" }} />
          {productsWithNotes.map((product, index) => (
            <div key={index}>
              <b>
                {index + 1}. {product.product_title}
              </b>
              <h6 style={{ lineHeight: 1, marginTop: "10px" }}>{product.product_additional_note}</h6>
            </div>
          ))}
        </div>
      }
      placement="top"
      arrow
    >
      {label}
    </Tooltip>
  );
};

export default ColoredSVG;
